import { api, saveSession } from '../api.js';
import LoginForm from './LoginForm.jsx';

export default function Login({ onLogin }) {
  return (
    <LoginForm
      title="Sign in"
      helpText="Enter the credentials provided by IBMA."
      loginFn={(u, p) => api.login(u, p)}
      saveSessionFn={saveSession}
      onLogin={onLogin}
    />
  );
}
